import { generateRandomPassword } from '@/shared/utils/generate-random-password'

export function random(min = 0, max = 1) {
  return Math.random() * (max - min) + min
}

export function randomInt(min = 0, max = 1) {
  return Math.round(random(min, max))
}

export function randomString(length: number = 16) {
  return generateRandomPassword(0, 0, 0, 0, length)
}
